// src/components/ForwardMessageDialog.js

import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, List, ListItem, ListItemButton, ListItemAvatar, Avatar, ListItemText, Checkbox, DialogActions, Button, Box, CircularProgress } from '@mui/material';
import { useConnections } from '../hooks/useConnections';

const ForwardMessageDialog = ({ open, onClose, onForward }) => {
  const { connections, loading } = useConnections();
  const [selected, setSelected] = useState([]);

  const handleToggle = (uid) => {
    const currentIndex = selected.indexOf(uid);
    const newSelected = [...selected];
    if (currentIndex === -1) {
      newSelected.push(uid);
    } else {
      newSelected.splice(currentIndex, 1);
    }
    setSelected(newSelected);
  };

  const handleConfirmForward = () => {
    onForward(selected);
    setSelected([]);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Forward message to...</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}><CircularProgress /></Box>
        ) : (
          <List dense>
            {connections.map(user => (
              <ListItem key={user.uid} disablePadding secondaryAction={
                <Checkbox edge="end" onChange={() => handleToggle(user.uid)} checked={selected.indexOf(user.uid) !== -1} />
              }>
                <ListItemButton>
                  <ListItemAvatar><Avatar src={user.photoURL} /></ListItemAvatar>
                  <ListItemText primary={user.displayName} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleConfirmForward} variant="contained" disabled={selected.length === 0}>
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ForwardMessageDialog;